import React from 'react';
import { BodyText } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';

export default function ConfirmationTitle(props) {
  return <BodyText style={{ marginBottom: '36px' }}>{props.message}</BodyText>;
}

ConfirmationTitle.propTypes = {
  message: PropTypes.string,
};
